import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum DesignPresetsErrorCode {
  UnknownDesignPreset = 'UnknownDesignPreset',
}

class DesignPresetsError extends BaseError<DesignPresetsErrorCode> {
  constructor(message: string, code: DesignPresetsErrorCode) {
    super(message, code, 'DesignPresets Private API Error');
  }

  withPreset(preset: string) {
    this.state.preset = preset;
    return this;
  }

  withAvailablePresets(presets: string[]) {
    this.state.presets = presets.join(' / ');
    return this;
  }
}

export const createDesignPresetsError = createErrorBuilder<
  DesignPresetsErrorCode,
  DesignPresetsError
>(DesignPresetsError);
